import { useFormikContext } from 'formik';
import Spacer from '@antimatterhq/ui/components/spacer';
import { Text } from '@antimatterhq/ui/components/typography';
import {
  ProcessingScheduleRadioGroup,
  ComputeResourcesRadioGroup,
} from '@/components/radio';
import { AddDetectionRuleSchemaValues } from '@/zod/schemas/detectionRules/AddDetectionRule';

export const RuleProcessingScheduleSection = () => {
  const { values, handleChange, handleBlur, touched, errors } =
    useFormikContext<AddDetectionRuleSchemaValues>();

  return (
    <>
      <Text size="base" bold>
        Rule processing schedule
      </Text>
      <Spacer size="base" />
      <ProcessingScheduleRadioGroup
        handleChange={handleChange}
        values={values}
        errors={errors}
        touched={touched}
        handleBlur={handleBlur}
      />
      <Spacer size="lg" />
      <Text size="base" bold className="mb-2 mt-4 block">
        Compute resources
      </Text>
      <div className="max-w-form">
        <ComputeResourcesRadioGroup
          handleChange={handleChange}
          values={values}
          errors={errors}
          touched={touched}
          handleBlur={handleBlur}
        />
      </div>
    </>
  );
};
